<template>
  <template v-if="Array.isArray(store.state.base.alert.messages) && store.state.base.alert.messages.length">
    <div :class="`${store.state.base.alert.color} border px-4 py-3 rounded`" role="alert">
      <div v-for="(errorMessage, index) in store.state.base.alert.messages" :key="`errorMessage-${index}`">
        {{ errorMessage }}
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

import { useStore } from '@/store/index'

export default defineComponent({
  setup() {
    const store = useStore()

    onMounted(() => {
      if (! store.state.base.alert.persistent) {
        store.commit('base/setAlertMessages', { messages: undefined })
      } else {
        store.commit('base/setAlertMessages', { messages: store.state.base.alert.messages, persistent: false })
      }
    })

    return {
      store
    }
  },
})
</script>
